<template>
  <div class="task-form">

    <el-card
        v-if="selected_trans&&ready"
        style="padding: 10px">
      <el-row slot="header">

        <el-col
            :xs="12"
            :sm="12"
            :span="12">
          <s-button
              type="danger"
              confirm='Are you sure'
              @execute="removeIt">
            <i class="material-icons">delete_forever</i></s-button>
        </el-col>
        <el-col
            :xs="12"
            :sm="12"
            :span="12"
            class="text-right">
          <!--          <el-button-->
          <!--              type="primary"-->
          <!--              @click="copyTrans">-->
          <!--            <i class="material-icons">alarm_on</i>-->
          <!--          </el-button>-->
          <el-button
              type="primary"
              @click="saveTrans">
            <i class="material-icons">done</i>
          </el-button>
        </el-col>


      </el-row>
      <el-row

          :gutter="20"
          style="padding-bottom: 10px">
        <el-col :sm="8">
          <div>Type</div>
          <s-select v-if="typeoptionsProvider" :options-repo="typeoptionsProvider" v-model="selected_trans.type"
                    allowCreate value-prop="type" label-prop="type"></s-select>
          <s-select :options="typeoptions" v-model="selected_trans.type" v-else></s-select>

        </el-col>
        <el-col :sm="16">
          <div>Title</div>
          <el-input
              placeholder="Title"
              v-model="selected_trans.title"/>

        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="18">
          <div>Discription</div>
          <el-input
              type="textarea"
              xchange="pipeActions(['=>fueldrafts/update'],selected_trans);"
              v-model="selected_trans.discription"></el-input>
        </el-col>
        <el-col :sm="6">
          <div>Cost</div>
          <el-input
              @change="pipeActions(['=>fueldrafts/update'],selected_trans);"
              v-model="selected_trans.cost"></el-input>
        </el-col>
      </el-row>
      <el-card>
        <el-row style="padding: 3px;background-color: #86efe5">
          <el-col
              style="background-color: #002316;padding: 4px"
              :sm="8">
            <div style="font-weight:bold;color: green ">Time</div>

            <el-date-picker
                value-format="timestamp"
                format="dd/MM/yyyy"
                type="date"
                placeholder="Related/Created Time"
                v-model="selected_trans.timeJS"
                xchange="pipeActions(['=>fueldrafts/update'],selected_trans);"
                style="width: 100%;"></el-date-picker>
          </el-col>
          <el-col
              style="background-color: #f1a8a8;padding: 4px"
              :sm="8">
            <div style="font-weight:bold;color: red ">Alert Time</div>

            <el-date-picker
                value-format="timestamp"
                format="dd/MM/yyyy"
                type="date"
                placeholder="Pick a Alert Date"
                v-model="selected_trans.alerttimeJS"
                xchange="pipeActions(['=>fueldrafts/update'],selected_trans);"
                style="width: 100%;"></el-date-picker>
          </el-col>
          <el-col
              :sm="8"
              style="background-color: yellowgreen;padding: 4px">
            <div>Exec Time</div>
            <el-date-picker
                type="date"
                xinput="pipeActions(['=>fueldrafts/update'],selected_trans);"
                value-format="timestamp"
                format="dd/MM/yyyy"
                placeholder="Pick a Exec Date"
                v-model="selected_trans.exectimeJS"
                style="width: 100%;"></el-date-picker>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="12">
            <div>Alert Kilometers</div>
            <el-input
                placeholder="Alert Kilometers"
                xchange="pipeActions(['=>fueldrafts/update'],selected_trans);"
                v-model="selected_trans.alertkilometers"></el-input>
          </el-col>
          <el-col :sm="12">
            <div>Kilometers</div>
            <el-input
                placeholder="Kilometers"
                xchange="pipeActions(['=>fueldrafts/update'],selected_trans);"
                v-model="selected_trans.runkilometers"></el-input>
          </el-col>
        </el-row>
      </el-card>
      <el-card
          title="When do you want to repeat?"
          style="padding: 10px">
        <el-form :inline="true">
          <el-form-item label="Repeat ">

            <el-select
                v-model="selected_trans.repeat.repeatStep"
                placeholder="Please select time step">
              <el-option
                  label="Never"
                  value="never"></el-option>
              <el-option
                  label="Months"
                  value="month"></el-option>
              <el-option
                  label="Years"
                  value="year"></el-option>
            </el-select>


          </el-form-item>
          <el-form-item label=" every ">
            <el-input-number
                :min="0"
                :max="10"
                v-model="selected_trans.repeat.every"
                autocomplete="off"
                :disabled="selected_trans.repeat.repeatStep=='never'"
                @change="repeatOnDate = null"></el-input-number>
          </el-form-item>
          <el-button style="float: right"
                     type="primary"
                     @click="copyTrans">
            <i class="material-icons">alarm_on</i>
          </el-button>
          <!--          <h3 >Or choose</h3 >-->
          <!--          <el-form-item label="Create similar specific date" >-->
          <!--            <el-date-picker-->
          <!--                type="date"-->
          <!--                placeholder="choose a date here"-->
          <!--                @change="selected_trans.repeat.every = 0;selected_trans.repeat.repeatStep='never'"-->
          <!--                value-format="timestamp"-->
          <!--                format="dd/MM/yyyy"-->
          <!--                v-model="selected_trans.repeatOnDate"-->
          <!--                style="width: 100%" ></el-date-picker >-->
          <!--          </el-form-item >-->
        </el-form>

      </el-card>

    </el-card>
    <div v-else><i class="el-icon-loading"></i></div>
  </div>

</template>

<script>
import * as api from "~/api/resource";
import moment from "moment";
import {removeObject} from "../../../api/resource";

export default {
  name: "VehicleTaskForm",
  props: {
    vehicle: {
      type: Object,
      default: () => null
    },
    taskId: {
      type: [String,
        Number], default: null
    },
  },
  data() {
    return {
      selected_trans: null,
      typeoptions: null,
      typeoptionsProvider: null,
      ready: false
    }
  },
  mounted() {
    if (_.isArray(this.$userProfile.vehicleNotificationTypes))
      this.typeoptions = this.$userProfile.vehicleNotificationTypes
    else this.typeoptionsProvider = this.$userProfile.vehicleNotificationTypes
    if (this.selected_trans&&!this.selected_trans.timeJS)
      this.$set(this.selected_trans, 'timeJS', (new Date()).getTime())
    this.$nextTick(() => this.ready = true)
  },
  methods: {
    copyTrans() {
      let cp = JSON.parse(JSON.stringify(this.selected_trans))
      _log_('selected_trans', this.selected_trans.repeat.every, this.selected_trans.alerttimeJS + '---')
      this.selected_trans = null
      // _log_('selected_trans', this.selected_trans, this.selected_trans.alerttimeJS + '---')
      cp.id = null
      cp.exectimeJS = null
      // cp.alerttimeJS = moment(cp.alerttimeJS).add('years', 3).format('x')
      if (cp.alerttimeJS && cp.repeat.repeatStep != 'never')
        cp.alerttimeJS = moment(cp.alerttimeJS).add(cp.repeat.repeatStep + 's', cp.repeat.every).format('x') * 1
      _log_('selected_trans', cp, cp.alerttimeJS)
      // this.selected_trans = cp
      setTimeout(() => this.selected_trans = cp, 500)
      // this.$nextTick(() => this.selected_trans = cp)
    },
    async removeIt() {
      this.selected_trans = await api.removeObject(
          "fueldrafts",
          this.selected_trans
      );
      this.$emit('done', this.selected_trans)
    },
    async saveTrans() {
      this.selected_trans = await api.updateProcessor(
          "fueldrafts/update",
          this.selected_trans
      );
      this.$emit('done', this.selected_trans)
    }
  },
  watch: {
    taskId: {
      immediate: true,
      // deep: true,
      async handler(v, vo) {
        _log_('fueldrafts', v)
        if (v == vo) return
        if (v == 'new') {
          if (this.vehicle)
            this.selected_trans = {assetId: this.vehicle.id, repeat: {every: 1, repeatStep: 'never'}}
        } else
          this.selected_trans = await api.getObject('fueldrafts', v)
        if (this.selected_trans&&!this.selected_trans.timeJS)
          this.$set(this.selected_trans, 'timeJS', (new Date()).getTime())
      }
    }
  }
}
</script>

<style>
.task-form .el-row {
  padding: 5px;
}
</style>
